const CommentIcon = ({ className, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7917 1.4585H8.20842C4.83002 1.4585 3.14082 1.4585 2.09128 2.51188C1.04175 3.56527 1.04175 5.26067 1.04175 8.65148V9.10104C1.04175 12.4918 1.04175 14.1872 2.09128 15.2406C2.5754 15.7265 3.25621 16.0508 4.13646 16.2134C4.40681 16.2633 4.54199 16.2883 4.6007 16.373C4.65941 16.4578 4.6353 16.5928 4.58708 16.8628C4.47034 17.5163 4.48878 18.1073 4.90789 18.4205C5.34712 18.7412 6.04703 18.3987 7.44684 17.7136C7.60189 17.6377 7.75748 17.56 7.91338 17.482L7.91576 17.4809C8.74681 17.0654 9.59375 16.6421 10.4969 16.4334C10.8898 16.3436 11.2897 16.3053 11.7917 16.294C15.1701 16.294 16.8593 16.294 17.9089 15.2406C18.9584 14.1872 18.9584 12.4918 18.9584 9.10104V8.65148C18.9584 5.26067 18.9584 3.56527 17.9089 2.51188C16.8593 1.4585 15.1701 1.4585 11.7917 1.4585ZM13.9584 11.2502C13.9584 11.5953 13.6786 11.8752 13.3334 11.8752H6.66675C6.32157 11.8752 6.04175 11.5953 6.04175 11.2502C6.04175 10.905 6.32157 10.6252 6.66675 10.6252H13.3334C13.6786 10.6252 13.9584 10.905 13.9584 11.2502ZM10.6251 7.0835C10.6251 7.42867 10.3453 7.7085 10.0001 7.7085H6.66675C6.32157 7.7085 6.04175 7.42867 6.04175 7.0835C6.04175 6.73832 6.32157 6.4585 6.66675 6.4585H10.0001C10.3453 6.4585 10.6251 6.73832 10.6251 7.0835Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default CommentIcon;
